import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const branchEmployeesWidget: DashboardWidgetConfiguration = {
  widgetId: "branch.employees",
  name: "Branch employees",
  description: "Branch employees for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "hr.current-employments",
      ...period(1),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "employment_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Employees",
    subtext: "active today",
    icon: "users",
    color: "purple",
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
